export function getSnowplowDuid(cookieName) {
	var cookieName = cookieName || '_sp_';
	var matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
	var match = document.cookie.match(matcher);
	var split = match[1].split('.');

	if (match && match[1]) {
		return {
			domain_userid: split[0],
			domain_sessionidx: split[2],
			domain_sessionid: split[5],
		};
	} else {
		return false;
	}
}
